import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Warranty = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
  >
    <path
      fill={props.color || theme.palette.grey600}
      fillRule="evenodd"
      d="M11.676 4.084a.667.667 0 0 1 .544-.047l.104.047 6 3.333c.181.101.303.28.335.48l.008.103v4.018c-.106 3.898-1.865 6.446-6.46 7.949a.667.667 0 0 1-.414 0c-4.489-1.468-6.271-3.933-6.45-7.696L5.333 12V8c0-.208.097-.401.258-.526l.085-.057 6-3.333ZM12 5.429 6.667 8.392v3.59c.086 3.202 1.376 5.21 5.01 6.535l.322.113.253-.088c3.511-1.26 4.864-3.145 5.06-6.089l.015-.262.006-.191V8.392L12 5.429Zm2.927 4.874a.667.667 0 0 0-1.148-.673l-2.298 3.445-1.444-.963-.068-.04a.667.667 0 0 0-.672 1.15l2 1.333.067.04c.297.151.668.06.857-.225l2.667-4 .04-.067Z"
      clipRule="evenodd"
    />
  </svg>
);
